import { UserRoles } from 'common/types'
import { get } from 'hooks/use-http/useHttp'

export const fetchAllOnboardingQuestionsByRole = (role: UserRoles) => {
  let response
  if (role == UserRoles.Admin || role == UserRoles.Member) {
    response = get(`onboarding-question/role/${UserRoles.Member}`, { useApiKey: true })
  } else {
    response = get(`onboarding-question/role/${role}`, { useApiKey: true })
  }
  return response
}

export const useOnboardingQuestionsApi = () => {
  return {
    fetchAllOnboardingQuestionsByRole
  } as const
}
